<template>
  <div class="course-catalogue">
    <el-dialog
      :visible="dialogVisible"
      width="1280px"
      top="250px"
      :show-close="false"
      :before-close="handleClose"
      :lock-scroll="false"
    >
      <div class="content" id="test">
        <div class="title">
          {{
            type == 'domestic'
              ? '国内课程'
              : type == 'international'
              ? '国际课程'
              : ''
          }}
        </div>
        <div class="list">
          <div
            class="item"
            v-for="(item, index) in list"
            :key="index"
            @click="clickToPath(item.id)"
          >
            {{ item.title }}
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  props: {
    isShow: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: '',
    },
    list: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      dialogVisible: false,
    }
  },
  watch: {
    isShow: {
      immediate: true,
      handler: function (nl) {
        this.dialogVisible = nl
      },
    },
  },
  methods: {
    handleClose() {
      this.dialogVisible = false
      this.$emit('closeDiag', this.dialogVisible)
    },
    clickToPath(id) {
      this.$store.commit('changeTitle', id)
      this.dialogVisible = false
      this.$emit('closeDiag', this.dialogVisible)
      window.open(
        this.$router.resolve({
          path: `/courseDetails/${this.type}/page/${id}`,
        }).href,
        '_blank'
      )
    },
  },
}
</script>
<style lang="less">
.course-catalogue {
  .el-dialog {
    border-radius: 12px !important;
    .el-dialog__header,
    .el-dialog__body {
      padding: 0;
    }
  }
}
</style>
<style lang="less" scoped>
.course-catalogue {
  .content {
    padding: 50px 40px 20px 40px;
    pointer-events: auto;
    .title {
      width: 88px;
      height: 22px;
      line-height: 24px;
      color: rgba(68, 68, 82, 100);
      font-size: 22px;
      font-weight: bold;
      text-align: left;
      margin-top: -20px;
    }
    .list {
      display: flex;
      justify-content: flex-start;
      flex-wrap: wrap;
      padding-top: 36px;
      .item {
        width: 20%;
        left: 385px;
        line-height: 18px;
        color: rgba(68, 68, 82, 100);
        font-size: 18px;
        text-align: left;
        margin-bottom: 30px;
        cursor: pointer;
        &:hover {
          color: #3263ff;
        }
      }
    }
  }
}
</style>
